import React, {Component} from "react";
import {COLUMNS, DATA_BY_COLUMN} from "./columns";

export class ColumnsSelect extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.props.onChange(event.target.value);
    }

    render() {
        let selected = this.props.selected;

        if(this.props.readOnly===true) {
            return <input value={DATA_BY_COLUMN[selected].Spanish} readOnly={true} className={"form-control"}/>
        }

        return (<select className={"form-control"}
                        value={selected} {...this.props}
                        onChange={this.handleChange}
            >
                {COLUMNS.map((option) => (
                    <option value={option}
                            key={option}
                    >{DATA_BY_COLUMN[option].Spanish}</option>
                ))}
            </select>
        )
    }
}
